import { render, staticRenderFns } from "./profileWallet.vue?vue&type=template&id=dac18ebc"
import script from "./profileWallet.vue?vue&type=script&lang=js"
export * from "./profileWallet.vue?vue&type=script&lang=js"
import style0 from "./profileWallet.vue?vue&type=style&index=0&id=dac18ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports